import axios from './axios'
import { formDataRequest } from './axios'

export const rocketChatLogin = personId =>
  axios.get(`/rocket_chat/login/${personId}`)

export const getRocketChatRooms = data =>
  axios.get(`/rocket_chat/rooms?person_id=${data.person_id}&client_id=${data.client_id}`)

export const getRocketChatMessages = data =>
  axios.get(`/rocket_chat/messages?room_id=${data.roomId}&person_id=${data.personId}&isDm=${data.isDm}&count=${data.count}&ts=${data.ts}&next=${data.next}&inclusive=${data.inclusive}&viewer_id=${data.viewerId}`)

export const getRocketMessagesReceipt = data =>
  axios.get(`/rocket_chat/read_receipt?channels=${data.channels}&person_id=${data.personId}`)

// Get all threads in a channel
export const getChannelThreadMessages = data =>
  axios.get(`/rocket_chat/allThreads?room_id=${data.roomId}&person_id=${data.personId}`)

// Get all messages in a specific thread
export const getChatThreadMessages = data =>
  axios.get(`/rocket_chat/thread?thread_id=${data.threadId}&person_id=${data.personId}`)

// Delete a specific message
export const deleteRocketChatMessage = data =>
  axios.delete(
    `/rocket_chat/delete_message?message_id=${data.messageId}&room_id=${data.roomId}&person_id=${data.personId}`
  )

export const getPinnedMessages = data =>
  axios.get(
    `/rocket_chat/pinned_messages?room_id=${data.roomId}&person_id=${data.personId}`
  )

export const updateRocketChatMessage = data =>
  axios.put('/rocket_chat/edit_message', data)

export const pinRocketChatMessage = data =>
  axios.post('/rocket_chat/pin_message', data)

export const unpinRocketChatMessage = data =>
  axios.post('/rocket_chat/unpin_message', data)

export const getCommunityMembers = data =>
  axios.get('/rocket_chat/community_members', data)

export const createDM = data => {
  return axios.post('/rocket_chat/create_dm', data)
}

export const sendMessageNotification = (data) =>
  axios.post(`/message/notify?client_id=${data.client_id}`, {
    text: data.text,
    ...(data.is_DM ? { is_DM: true } : {}),
    ...(data.receiver_id ? { receiver_id: data.receiver_id } : {})
  })

export const uploadFile = ({ personId, file }) => {
  return uploadToGetStaticUrl({
    personId,
    file
  })
}

export const uploadToGetStaticUrl = ({
  file,
  personId,
  onBeforeUpload,
  progressCallback,
  source
}) => {
  let path = `/files?person_id=${personId}`
  const formData = new FormData()
  formData.append('file', file)
  return formDataRequest({
    method: 'post',
    path,
    data: formData,
    onBeforeUpload,
    onUploadProgress: (process) =>
      progressCallback && progressCallback(process),
    cancelSource: source
  })
}

export const searchRocketChatMessages = (data) =>
  axios.get(`/rocket_chat/search_messages?room_id=${data.roomId}&person_id=${data.personId}&search_text=${data.searchText}`)

export const getRocketChatMessageById = data =>
  axios.get(`/rocket_chat/message?person_id=${data.personId}&message_id=${data.messageId}`)

export const sendRocketChatMessage = data =>
  axios.post('/rocket_chat/message', data)
